import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  FormFeedback,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Select from "react-select";

//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addBatch, editBatch } from "store/actions";
import { withTranslation } from "react-i18next";
import {
  participantsInvitaionsList,
  participantsRemindersList,
  ratersInvitationsList,
  fetchQuestionnaireList,
} from "helpers/backend_api_helper";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { listGroupNormsDetails } from "store/actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddEditModal = (props) => {
  const { modal, toggle, isEdit, itemData, fetchBatchListData } = props;
  const [participantsInvitation, setParticipantsInvitation] = useState([]);
  const [participantsReminders, setParticipantsReminders] = useState([]);
  const [ratersInvitations, setRatersInvitations] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [deadLine, setDeadline] = useState(null);
  const [batchData, setBatchData] = useState();
  // questionnaire select
  const [options, setoptions] = useState([]);
  const [selectValue, setSelectValue] = useState();

  const { error, success, loading, editLoading } = useSelector((state) => ({
    loading: state.Batches.loading,
    error: state.Batches.error,
    success: state.Batches.success,
    editLoading: state?.Batches?.editLoading,
  }));
  const dispatch = useDispatch();
  const utcDate = new Date(itemData?.deadline); // UTC Date
  const localDate = itemData?.deadline
    ? new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000)
    : null;
  
  useEffect(() => {
  
    setBatchData(itemData);
    // setDeadline(localDate);
  }, [itemData]);

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate())?.padStart(2, "0");
    const month = String(date.getMonth() + 1)?.padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: batchData?.title || "",
      invitation_method: batchData?.invitation_method || "username",
      participant_invitation:
        batchData?.participant_invitation ||
        (participantsInvitation && participantsInvitation[0]?.id),
      participant_reminder:
        batchData?.participant_reminder ||
        (participantsReminders && participantsReminders[0]?.id),
      rater_invitation:
        batchData?.rater_invitation ||
        (ratersInvitations && ratersInvitations[0]?.id),
      questionnaire_id:
        batchData?.questionnaire_id || (questionnaire && questionnaire[0]?.id),
      norms: batchData?.norms || "",
      is_active: batchData?.is_active || "Y",
    },
    validationSchema: Yup.object({
      title: Yup.string().required(props.t("Please Enter Batch Name")),
      invitation_method: Yup.string().required(
        props.t("Please Invitation Method")
      ),
      participant_invitation: Yup.string().required(
        props.t("Please Enter Participant Invitation")
      ),
      participant_reminder: Yup.string().required(
        props.t("Please Enter Participant Reminder")
      ),
      rater_invitation: Yup.string().required(
        props.t("Please Enter Raters Invitation")
      ),
      // questionnaire_id: Yup.string().required(props.t("Please Enter Questionnaire")),
      // deadline: Yup.string().required(props.t("Please Enter Deadline")),
      // norms: Yup.string().required(props.t("Please Enter Norms")),
      is_active: Yup.string().required(
        props.t("Please Enter Questionnaire Status")
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      if (!deadLine && !isEdit) {
        toastr.error("Please Enter Deadline.");
        return;
      }

      // if(!selectValue?.value){
      // toastr.error("Please Enter Deadline.");
      // return
      // }

      if (values.norms == "group" && !values.norms_id) {
        values.norms_id = groupNormsList[0]?.id;
      }
    
      values = {
        ...values,
        deadline:
          deadLine != null
            ? new Date(
              Date.UTC(
                deadLine.getFullYear(),
                deadLine.getMonth(),
                deadLine.getDate(),
                deadLine.getHours(),
                deadLine.getMinutes()
              )
            )
            : itemData?.deadline,
      };

      if (isEdit) {
        values = {
          ...values,
          questionnaire_id: selectValue?.value
            ? selectValue?.value
            : questionnaire[0]?.id,
        };

        dispatch(
          editBatch(values, batchData?.id, (res) => {
            if (res.status === "success") {
              toastr.success(res.message);

              resetForm({
                title: "",
                invitation_method: "",
                participant_invitation: "",
                participant_reminder: "",
                rater_invitation: "",
                questionnaire_name: "",
                client_name: "",
                creation_date: "",
                is_active: "",
              });
              fetchBatchListData();
              toggle();
              setDeadline();
            } else {
              toastr.error(res.message);
              toggle();
            }
          })
        );
      } else {
        values = {
          ...values,
          questionnaire_id: selectValue?.value
            ? selectValue?.value
            : questionnaire[0]?.id,
        };
        dispatch(
          addBatch(values, props?.router?.navigate, (res) => {
            if (res?.status === "success") {
              toastr.success(res.message);

              resetForm({
                title: "",
                invitation_method: "",
                participant_invitation: "",
                participant_reminder: "",
                rater_invitation: "",
                questionnaire_name: "",
                client_name: "",
                creation_date: "",
                is_active: "",
              });
              setDeadline();
              fetchBatchListData();
              toggle();
            } else {
              toastr.error(res.message);
              toggle();
            }
          })
        );
      }
    },
  });

  const fetchParticipantsInvitation = async () => {
    try {
      const list = await participantsInvitaionsList();
      if (list?.status === "success") {
        setParticipantsInvitation(list?.data);
      }
    } catch (error) { }
  };
  const fetchParticipantsReminders = async () => {
    try {
      const list = await participantsRemindersList();
      if (list?.status === "success") {
        setParticipantsReminders(list?.data);
      }
    } catch (error) { }
  };

  const fetchRatersInvitations = async () => {
    try {
      const list = await ratersInvitationsList();
      if (list?.status === "success") {
        setRatersInvitations(list?.data);
      }
    } catch (error) { }
  };
  const fetchQuestionnaire = async () => {
    try {
      const list = await fetchQuestionnaireList();
      if (list?.status === "success") {
       
        setQuestionnaire(list?.data);
        // setSelectValue({value: list?.data[0]?.id, label: list?.data[0].questionnaire_name})
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchParticipantsInvitation();
    fetchParticipantsReminders();
    fetchRatersInvitations();
    fetchQuestionnaire();
  }, []);

  useEffect(() => {
    if (isEdit) {

      setSelectValue({
        value: batchData?.questionnaire_id,
        label: batchData?.questionnaire_name,
      });
    }
    let modifiedList = questionnaire?.map((dky) => ({
      value: dky.id,
      label: dky.questionnaire_name,
    }));
    setoptions(modifiedList);
  }, [questionnaire, batchData]);

  const handleSelectChange = (obj) => {
    setSelectValue(obj);
  };

  const onResetForm = () => {
    validation.resetForm({
      title: "",
      invitation_method: "",
      participant_invitation: "",
      participant_reminder: "",
      rater_invitation: "",
      questionnaire_name: "",
      client_name: "",
      creation_date: "",
      is_active: "",
    });
    setDeadline();
    setSelectValue(null);
  };

  // on select group norms
  const [groupNormsList, setGroupNormsList] = useState();
  const fetchGroupNormsDetailsList = (data) => {
    dispatch(
      listGroupNormsDetails(data, (res) => {
        if (res?.status === "success") {
          setGroupNormsList(Array?.isArray(res?.data) ? res?.data : []);
        }
      })
    );
  };
  useEffect(() => {
    fetchGroupNormsDetailsList("");
  }, []);


  return (
    <React.Fragment>
      <Modal
        className="batches-modal-add"
        isOpen={modal}
        toggle={() => {
          toggle();
          // onResetForm()
        }}
      >
        <ModalHeader
          tag="h4"
          toggle={() => {
            toggle();
            // onResetForm()
          }}
        >
          {!!isEdit ? props.t("Edit Batch") : props.t("Add Batch")}
        </ModalHeader>
        <ModalBody>
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="flex-form-batches">
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Batch Name")}:
                </Label>
                <Input
                  name="title"
                  className="form-control"
                  placeholder={props.t("Enter Batch Name")}
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.title || ""}
                  invalid={
                    validation.touched.title && validation.errors.title
                      ? true
                      : false
                  }
                />
                {validation.touched.title && validation.errors.title ? (
                  <FormFeedback type="invalid">
                    {validation.errors.title}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Participants Invitation")}:
                </Label>
                <Input
                  name="participant_invitation"
                  className="form-control"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.participant_invitation || ""}
                  invalid={
                    validation.touched.participant_invitation &&
                      validation.errors.participant_invitation
                      ? true
                      : false
                  }
                >
                  {/* <option value="" disabled>{props.t("Select Participants Invitation")}</option> */}
                  {participantsInvitation?.map((data, key) => {
                    return (
                      <option key={key} value={data?.id}>
                        {data?.invitation_title}
                      </option>
                    );
                  })}
                </Input>
                {validation.touched.participant_invitation &&
                  validation.errors.participant_invitation ? (
                  <FormFeedback type="invalid">
                    {validation.errors.participant_invitation}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Participants Reminder")}:
                </Label>
                <Input
                  name="participant_reminder"
                  className="form-control"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.participant_reminder || ""}
                  invalid={
                    validation.touched.participant_reminder &&
                      validation.errors.participant_reminder
                      ? true
                      : false
                  }
                >
                  {/* <option value="" disabled>{props.t("Select Participants Reminder")}</option> */}
                  {participantsReminders?.map((data, key) => {
                    return (
                      <option key={key} value={data?.id}>
                        {data?.invitation_title}
                      </option>
                    );
                  })}
                </Input>
                {validation.touched.participant_reminder &&
                  validation.errors.participant_reminder ? (
                  <FormFeedback type="invalid">
                    {validation.errors.participant_reminder}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Rater Invitation")}:
                </Label>
                <Input
                  name="rater_invitation"
                  className="form-control"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.rater_invitation || ""}
                  invalid={
                    validation.touched.rater_invitation &&
                      validation.errors.rater_invitation
                      ? true
                      : false
                  }
                >
                  {/* <option value="" disabled>{props.t("Select Rater Invitation")}</option> */}
                  {ratersInvitations?.map((data, key) => {
                    return (
                      <option key={key} value={data?.id}>
                        {data?.invitation_title}
                      </option>
                    );
                  })}
                </Input>
                {validation.touched.rater_invitation &&
                  validation.errors.rater_invitation ? (
                  <FormFeedback type="invalid">
                    {validation.errors.rater_invitation}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Questionnaire Name")}:
                </Label>
                <Select
                  className="custom-select-search-option"
                  options={options}
                  value={
                    selectValue
                      ? selectValue
                      : {
                        value: questionnaire[0]?.id,
                        label: questionnaire[0]?.questionnaire_name,
                      }
                  }
                  name="question_id"
                  onChange={handleSelectChange}
                />
              </div>

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Batch Deadline")}:
                </Label>

                <DatePicker
                  name="scored_date"
                  className="form-control d-block"
                  selected={deadLine ? deadLine : localDate}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  scrollableYearDropdown
                  yearDropdownItemNumber={201} // Set the number of years to show (this doesn't actually limit it)
                  // Make the year dropdown scrollable
                  // Custom year dropdown to display years from 1900 to 2100
                  yearDropdownItems={Array.from(
                    { length: 201 },
                    (v, k) => k + 1900
                  )}
                  placeholderText="YYYY-MM-DD"
                  onChange={(date) => {
                    setDeadline(date);
                  }}
                  dateFormat="yyyy-MM-dd"
                />
                {/* <Flatpickr
                                    name="scored_date"
                                    className="form-control d-block"
                                    placeholder="dd-mm-yyyy"
                                    options={{
                                      altInput: true,
                                      altFormat: "d-m-Y", 
                                      dateFormat: "d-m-Y",
                                    
                                     
                                    }}
                                    value={deadLine ? new Date(deadLine).toISOString().split("T")[0] : ''}
                                    onChange={(e) => setDeadline(e[0])}
                                    
                                /> */}
                {/* <Input
                                    name="deadline"
                                    className="form-control"
                                    placeholder={props.t("Enter Batch Deadline")}
                                    type="date"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={(validation.values.deadline || "").split("T")[0]}
                                    invalid={
                                        validation.touched.deadline && validation.errors.deadline ? true : false
                                    }
                                /> */}
                {/* {validation.touched.deadline && validation.errors.deadline ? (
                                    <FormFeedback type="invalid">{validation.errors.deadline}</FormFeedback>
                                ) : null} */}
              </div>
              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Choose Norm")}:
                </Label>
                <Input
                  name="norms"
                  className="form-control"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.norms || ""}
                  invalid={
                    validation.touched.norms && validation.errors.norms
                      ? true
                      : false
                  }
                >
                  {/* <option value="" disabled>{props.t("Select Choose Norm")}</option> */}
                  <option value=""></option>
                  <option value="global">Global Norms</option>
                  <option value="group">Group Norms</option>
                </Input>
              </div>
              {validation.values.norms == "group" ? (
                <div className="mb-3 d-block modal-50">
                  <Label className="form-label m-0 pb-1">
                    {props.t("Choose Group Norms")}:
                  </Label>
                  <Input
                    name="norms_id"
                    className="form-control"
                    type="select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.norms_id || ""}
                    invalid={
                      validation.touched.norms_id && validation.errors.norms_id
                        ? true
                        : false
                    }
                  >
                    {/* <option value="" disabled>{props.t("Select Choose Norm")}</option> */}
                    {groupNormsList?.map((data) => {
                      return (
                        <option key={data.id} value={data.id}>
                          {data.norm_name}
                        </option>
                      );
                    })}
                  </Input>
                </div>
              ) : (
                ""
              )}

              <div className="mb-3 d-block modal-50">
                <Label className="form-label m-0 pb-1">
                  {props.t("Participation Invitation Method")}:
                </Label>
                <Input
                  name="invitation_method"
                  className="form-control"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.invitation_method || ""}
                  invalid={
                    validation.touched.invitation_method &&
                      validation.errors.invitation_method
                      ? true
                      : false
                  }
                >
                  {/* <option value="" disabled>{props.t("Select Participation Invitation Method")}</option> */}
                  <option value="username">User Name</option>
                  <option value="email">Email</option>
                </Input>
                {validation.touched.invitation_method &&
                  validation.errors.invitation_method ? (
                  <FormFeedback type="invalid">
                    {validation.errors.invitation_method}
                  </FormFeedback>
                ) : null}
              </div>
            </div>

            <div className="mb-3 d-flex align-items-center gap-3">
              <Label className="form-label m-0">{props.t("Status")}:</Label>
              <div className="d-flex align-items-center gap-2">
                <Input
                  id="active"
                  name="is_active"
                  type="radio"
                  checked={validation.values.is_active == "Y" ? true : false}
                  value="Y"
                  onClick={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.is_active && validation.errors.is_active
                      ? true
                      : false
                  }
                />
                <Label for="active" className="form-label m-0">
                  {props.t("Active")}
                </Label>
                <Input
                  id="inactive"
                  name="is_active"
                  checked={validation.values.is_active === "N" ? true : false}
                  value="N"
                  type="radio"
                  onClick={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.is_active && validation.errors.is_active
                      ? true
                      : false
                  }
                />
                <Label for="inactive" className="form-label m-0">
                  {props.t("In-Active")}
                </Label>
              </div>
              {validation.touched.is_active && validation.errors.is_active ? (
                <FormFeedback type="invalid">
                  {validation.errors.is_active}
                </FormFeedback>
              ) : null}
            </div>

            {editLoading ? (
              <div className="btn-login-admin mt-3 batches-add-modal-btn">
                <button
                  type="button"
                  className="btn btn-primary btn-block d-flex"
                  disabled
                >
                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                  {props.t("Submit")}
                </button>
              </div>
            ) : (
              <div className="btn-login-admin mt-3 batches-add-modal-btn">
                <button
                  className="btn btn-primary btn-block"
                  type="submit"
                // disabled
                >
                  {props.t("Submit")}
                </button>
              </div>
            )}
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

AddEditModal.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};
export default withTranslation()(AddEditModal);
